import { Box, Typography } from "@mui/material";
import React from "react";
import { primary } from "../../constants/theme";

const SuperUserProfile = ({ data, isHideTestimonialContent = false }) => {
  return (
    <>
      <Box
        className="modal-video"
        sx={{
          width: {
            xs: "95%",
            md: isHideTestimonialContent ? "430px" : "500px",
          },
          margin: "auto",
          height: { xs: "300px", md: "400px" },
        }}
      >
        <iframe
          title={"testimonial video"}
          className="youtube-video"
          maxWidth={isHideTestimonialContent ? "430px" : "500px"}
          maxHeight="400px"
          width="100%"
          height="100%"
          src={data?.videoUrl}
          frameborder="0"
          allowfullscreen
        ></iframe>
      </Box>
      {!isHideTestimonialContent && (
        <>
          <Typography
            style={{
              fontSize: "20px",
              fontWeight: 600,
              margin: "10px",
              marginBottom: "4px",
            }}
          >{`${data?.name}, ${data?.business}`}</Typography>
          <Typography
            style={{ fontSize: "12px", margin: "2px", marginLeft: "10px" }}
          >
            I save Rs 800 every day after i shifted to electric,{" "}
          </Typography>
          <Typography
            style={{ fontSize: "14px", marginLeft: "10px", fontWeight: 600 }}
          >
            Cost Per/Km -{" "}
            <span style={{ color: primary?.main }}>₹{data?.rate} 🚛</span>
          </Typography>
          <Typography
            style={{ fontSize: "14px", marginLeft: "10px", fontWeight: 600 }}
          >
            Monthly savings -{" "}
            <span style={{ color: primary?.main }}>₹{data?.earning}</span>{" "}
          </Typography>
        </>
      )}
    </>
  );
};

export const MemoizedSuperUserProfile = React.memo(SuperUserProfile);
